import React from 'react';
import {
    Box,
    Typography,
    Grid,
    Paper,
    Chip,
    Stack,
    IconButton,
    Tooltip,
} from '@mui/material';
import InventoryIcon from '@mui/icons-material/Inventory';
import ComputerIcon from '@mui/icons-material/Computer';
import MouseIcon from '@mui/icons-material/Mouse';
import KeyboardIcon from '@mui/icons-material/Keyboard';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VerifiedIcon from '@mui/icons-material/Verified';
import { getMediaUrl } from '../../../utils/urlHelper';

const AssetCard = ({ asset, onPreview }) => {
    const getIcon = (name) => {
        const n = name?.toLowerCase() || '';
        if (n.includes('laptop')) return <ComputerIcon />;
        if (n.includes('mouse')) return <MouseIcon />;
        if (n.includes('keyboard')) return <KeyboardIcon />;
        if (n.includes('phone') || n.includes('mobile')) return <PhoneAndroidIcon />;
        return <InventoryIcon />;
    };

    return (
        <Paper
            elevation={0}
            sx={{
                p: 2,
                borderRadius: '16px',
                border: '1px solid #eef0f4',
                transition: 'all 0.2s ease',
                '&:hover': {
                    borderColor: '#2f6bff40',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 6px 18px rgba(47, 107, 255, 0.12)',
                },
            }}
        >
            <Stack direction="row" spacing={2} alignItems="center">
                <Box
                    sx={{
                        width: 46,
                        height: 46,
                        borderRadius: '12px',
                        backgroundColor: 'rgba(47, 107, 255, 0.12)',
                        color: '#2f6bff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                    }}
                >
                    {getIcon(asset.asset_name)}
                </Box>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#1e293b' }}>
                        {asset.asset_name}
                    </Typography>
                    <Typography variant="caption" sx={{ color: '#94a3b8', display: 'block' }}>
                        ID: {asset.asset_id || 'N/A'}
                    </Typography>
                </Box>
                <Stack direction="row" spacing={1} alignItems="center">
                    {asset.attachment && (
                        <Tooltip title="View Document">
                            <IconButton
                                size="small"
                                onClick={() => onPreview(getMediaUrl(asset.attachment))}
                                sx={{ color: '#2f6bff' }}
                            >
                                <VisibilityIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    )}
                    <Chip
                        label="Assigned"
                        size="small"
                        color="success"
                        variant="outlined"
                        sx={{ fontWeight: 600, fontSize: '0.65rem', height: 20 }}
                    />
                </Stack>
            </Stack>
            {asset.provided_date && (
                <Box sx={{ mt: 1.5, pt: 1.5, borderTop: '1px solid #f8fafc' }}>
                    <Typography variant="caption" sx={{ color: '#94a3b8' }}>
                        Provided on: {asset.provided_date}
                    </Typography>
                </Box>
            )}
        </Paper>
    );
};

const EmpAssets = ({ data = [] }) => {
    return (
        <Box>
            {data.length > 0 ? (
                <Grid container spacing={2}>
                    {data.map((asset, index) => (
                        <Grid item xs={12} sm={6} key={index}>
                            <AssetCard
                                asset={asset}
                                onPreview={(url) => window.open(url, '_blank')}
                            />
                        </Grid>
                    ))}
                </Grid>
            ) : (
                <Paper
                    elevation={0}
                    sx={{
                        p: 6,
                        borderRadius: '18px',
                        border: '1px solid #eef0f4',
                        textAlign: 'center',
                        backgroundColor: '#f8fafc',
                    }}
                >
                    <InventoryIcon sx={{ fontSize: 48, color: '#cbd5e1', mb: 2 }} />
                    <Typography variant="h6" sx={{ color: '#64748b', mb: 1, fontWeight: 700 }}>
                        No Assets Assigned
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#94a3b8' }}>
                        You haven't been assigned any company assets yet.
                    </Typography>
                </Paper>
            )}

            {data.length > 0 && (
                <Box sx={{ mt: 3 }}>
                    <Chip
                        icon={<VerifiedIcon sx={{ fontSize: 16 }} />}
                        label="All assets verified by IT Department"
                        variant="outlined"
                        sx={{ color: '#64748b', borderColor: '#e2e8f0' }}
                    />
                </Box>
            )}
        </Box>
    );
};

export default EmpAssets;
